<template>
  <div class="flex flex-col gap-2">
    <div class="flex flex-wrap gap-3">
      <UButton
        type="button"
        color="neutral"
        variant="outline"
        icon="i-lucide-download"
        :loading="isDownloading"
        @click="download"
      >
        {{ $t('common.legalAgreement.download') }}
      </UButton>

      <UButton
        type="button"
        color="neutral"
        variant="outline"
        icon="i-lucide-printer"
        :loading="isPrinting"
        @click="print"
      >
        {{ $t('common.legalAgreement.print') }}
      </UButton>
    </div>

    <p
      v-if="actionProblem !== ''"
      class="text-danger text-sm"
      role="alert"
      data-testid="agreement-document-problem"
    >
      {{ actionProblem }}
    </p>
  </div>
</template>

<script setup lang="ts">
import UButton from '@nuxt/ui/components/Button.vue'
import { useLegalAgreementDocument } from '~/composables/useLegalAgreementDocument'

const props = defineProps<{
  /** Identifier of the legal agreement whose PDF is downloaded and printed. */
  legalAgreementId: string
}>()

const { actionProblem, download, isDownloading, isPrinting, print } = useLegalAgreementDocument(
  () => props.legalAgreementId
)
</script>
